import '@ui5/webcomponents-fiori/dist/SideNavigationSubItem.js';
import { withWebComponent } from '../../internal/withWebComponent';
/**
 * The `SideNavigationSubItem` is intended to be used inside a `SideNavigationItem` only.
 *
 * <ui5-link href="https://sap.github.io/ui5-webcomponents/playground/components/SideNavigationSubItem" target="_blank">UI5 Web Components Playground</ui5-link>
 */
const SideNavigationSubItem = withWebComponent('ui5-side-navigation-sub-item', ['icon', 'text'], ['selected'], [], []);
SideNavigationSubItem.displayName = 'SideNavigationSubItem';
export { SideNavigationSubItem };
